import React from 'react';
import styled from 'styled-components';
import { Box, Heading, Paragraph } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { colors, spaces, typography } from '@99designs/emu/settings';
import { publicImageUrl } from '../../../lib/publicImageUrl';
import StatBarChart from './Chart/StatBarChart';
import Media from './Media';
import Quote from './Quote';
import TextFullWidthMediaLayout from './TextFullWidthMediaLayout';
import { DWB21_Blue, DWB21_Purple, DWB21_Teal } from './colors';

const Wrapper = styled.div`
    max-width: 1440px;
`;

const MainHeading = styled(Heading)`
    text-align: left;
`;

const SubHeading = styled(Heading)`
    text-align: left;
`;

const MainContent = styled(Paragraph)`
    text-align: left;
`;

const AsideHeading = styled(Heading)`
    text-align: left;
    padding-top: ${spaces['2bu']};
`;

const CalloutQuote = styled.p`
    text-align: left;
    font-family: ${typography.fontFamilies.attribution};
    line-height: ${typography.lineHeights.typeScale.size5};
    font-style: italic;
    margin-bottom: ${spaces['1.5bu']};
    margin-top: ${spaces['2bu']};
    border-left: 1px solid ${colors.grey800};
    ${mediaQuery.minimum('normal')} {
        font-size: ${typography.typeScale.size6}px;
        padding-left: ${spaces['2bu']};
    }
    ${mediaQuery.between('small', 'medium')} {
        font-size: ${typography.typeScale.size5}px;
        padding-left: ${spaces['1bu']};
    }
`;

export default function Future() {
    return (
        <Wrapper>
            <TextFullWidthMediaLayout
                title={
                    <MainHeading appearanceLevel={0} accessibilityLevel={1} withDivider>
                        Future Focus
                    </MainHeading>
                }
                main={
                    <Box>
                        <SubHeading appearanceLevel={2} accessibilityLevel={2}>
                            Freelancers are stepping into their power.
                        </SubHeading>
                        <Box height="22px" />
                        <MainContent>
                            Freelance designers identified professional and personal growth
                            alongside financial success as the things most important to them. The
                            vast majority are earning more (71%) and have found better balance in
                            their lives over the past 12 months (60%).
                            <br />
                            <br />
                            {/* eslint-disable-next-line react/no-unescaped-entities */}
                            But they're not resting on their laurels.
                            <br />
                            <br />
                            With 78% having learned a new skill in the past 6 months, freelancers
                            are embracing their entrepreneurial drive, bettering themselves and
                            fueling their growth. With their optimism, upskilling and appetite for
                            social activism, freelance designers are positioning themselves to make
                            an even greater impact in 2022.
                        </MainContent>
                    </Box>
                }
                aside={
                    <Box>
                        <AsideHeading appearanceLevel={4} accessibilityLevel={4}>
                            On a scale of 0-100, on average designers answered:
                        </AsideHeading>
                        <CalloutQuote>
                            “I am optimistic about the future of the design industry”
                        </CalloutQuote>
                        <StatBarChart score={83} color={DWB21_Purple} />
                        <CalloutQuote>
                            “I am confident that I will reach my professional goals in the next 10
                            years”
                        </CalloutQuote>
                        <StatBarChart score={87} color={DWB21_Teal} />
                    </Box>
                }
                media={
                    <Media
                        fallbackImageUrl={publicImageUrl(`design-without-borders/future-focus.gif`)}
                        verticalCenterAlign={false}
                        crop={false}
                        width={{ extraLarge: '100%' }}
                        height={{
                            extraLarge: '100%',
                            large: '100%',
                            normal: '100%',
                            medium: '100%',
                        }}
                        absolutePositioned={false}
                    />
                }
            />
            <Box height="80px"></Box>
            <Quote
                backgroundColor={DWB21_Blue}
                text={
                    "If there is anything we've learned during the pandemic, it's that systems are beautifully complex and intertwined. And it’s designers who strive to shed away the layers of misconceptions, biases, and stereotypes that exist, approaching systemic problems through a perspective of growth and learning."
                }
                designerName={'Designer #8758, Canada'}
            />
        </Wrapper>
    );
}
